import { File } from '@/client/files';
import { User } from '@/client/users';
import { SystemRoles } from '@/client/users/types/roles.type';
import {
  CONTENT_GIF_MAX_SIZE,
  CONTENT_VIDEO_MAX_SIZE,
  COURSE_THUMBNAIL_MAX_SIZE,
} from '@/common/constants/files';

export const isVideoFile = (file?: Pick<File, 'mimeType'> | null) =>
  !!file?.mimeType?.startsWith('video/');

export const getContentMediaMaxSize = (mimeType: string) => {
  if (mimeType.startsWith('video/')) return CONTENT_VIDEO_MAX_SIZE;
  if (mimeType === 'image/gif') return CONTENT_GIF_MAX_SIZE;
  return COURSE_THUMBNAIL_MAX_SIZE;
};

export const canUploadContentVideo = (user?: User | null) =>
  [SystemRoles.SUPER_ADMIN, SystemRoles.DEVELOPER].includes(
    user?.role?.code as SystemRoles,
  );
